import { mapActions, mapGetters } from 'vuex';
import router from '@/router';

export default {
    data() {
        return {
            username: '',
            password: '',
            showPassword: false,
        };
    },

    computed: {
        ...mapGetters({
            user: 'user/user',
        }),
    },

    methods: {
        ...mapActions('user', ['loginViaPassword']),

        goToForgotPassword() {
            router.push('/forgot-password');
        },

        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
    },

    mounted() {
        this.$refs.firstNameInput.focus();
    },
};
